import React, { useEffect, useState } from "react"

const Image = ({ remoteImage, fallbackImageUrl, alt, ...props }) => {
	const [imageSrc, setImageSrc] = useState(fallbackImageUrl);

  useEffect(() => {
    const img = new window.Image();
    img.src = remoteImage;

    img.onload = () => setImageSrc(remoteImage);
    img.onerror = () => setImageSrc(fallbackImageUrl);
  }, [remoteImage, fallbackImageUrl]);

	if (!imageSrc) return null;
	
	return (
		<div className="d-flex jc-center">
			<img 
				alt={alt} 
				loading="lazy" 
				src={imageSrc}
				width={props.width}
				height={props.height}
			/>
		</div>
	)
}

export default Image
